import React, { useRef, useState, useEffect } from 'react';

import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import PresentationPdfComponent from './PDF/PresentationPDF/PresentationPDFComponent';
import Spinner from './Spinner/Spinner';
import Header from './UIHeader/Header';

import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';
import BackPageComponent from '../Containers/BackPage/BackPageComponent';
import CoverPageComponent from '../Containers/CoverPage/CoverPageComponent';
import FooterPageComponent from '../Containers/FooterPage/FooterPageComponent';
import MapboxComponent from '../Containers/MapboxPage/MapboxPageComponent';
import OptionDetailsPageComponent from '../Containers/OptionDetailsPage/OptionDetailsPageComponent';
import ShortlistPage from '../Containers/ShortlistPage/ShortlistPage';
import TablePagesComponent from '../Containers/TablePage/TablePagesComponent';
import { usePdf } from '../hooks/usePdf';
import useScroll from '../hooks/useScroll';
import * as actionTypes from '../store/actions/index.js';

function PresentationComponent(props) {
  const ref = useRef(null);
  const { isPdfContent, isOptionsDataSetForPDF, data } = props;
  const [IsSpinner, SetIsSpinner] = useState(false);

  const [IsPdf, setIsPdf] = useState(false);
  const currentDeal = useSelector((state) => state.comRed.currentDeal);
  // const { generatePDF } = usePdf(data.survey?.Client, data.survey?.targetMarket);
  const { generatePDF } = usePdf(currentDeal['Client Name'], currentDeal['Target Market']);
  const [pdfButtonClicked, setPdfButtonClicked] = useState(false);
  const dataOptions = useSelector((state) => state.optRed.data);
  const { surveyId } = useParams();

  const buttonClickHandler = async () => {
    props.setApiData(surveyId, true);
    setPdfButtonClicked(true);
    SetIsSpinner(true);
  };

  useEffect(() => {
    (async () => {
      let pdfFile;

      if (ref.current === null) {
        return;
      }
      if (IsPdf) {
        pdfFile = generatePDF(ref);
        props.setPdfDownload(false);
        props.updatePDFCounter();
      }

      if (pdfFile) {
        await pdfFile;
      }
      SetIsSpinner(false);
    })();

    return () => {
      setIsPdf(false);
    };
    // eslint-disable-next-line
  }, [isPdfContent]);

  useEffect(() => {
    if (isOptionsDataSetForPDF && pdfButtonClicked) {
      props.setPdfDownload(true);
      setIsPdf(true);
      setPdfButtonClicked(false);
      props.setOptionDataPDF(false);
    }
    // eslint-disable-next-line
  }, [isOptionsDataSetForPDF]);

  useScroll(IsSpinner);

  return (
    <div>
      {IsSpinner && <Spinner />}
      <div className={isPdfContent ? 'pdfapp' : ''} ref={ref}>
        {isPdfContent && <PresentationPdfComponent />}
        {!isPdfContent && (
          <>
            <ErrorBoundary>
              <CoverPageComponent />
              <div className="App">
                <Header />
                <MapboxComponent />
                <ShortlistPage pdfButtonClick={buttonClickHandler} />
                <TablePagesComponent />
                <OptionDetailsPageComponent />
              </div>
              <FooterPageComponent />
            </ErrorBoundary>
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isPdfContent: state.comRed.pdfDownload,
    isOptionsDataSetForPDF: state.optRed.isOptionsDataSetForPDF,
    data: state.optRed.data,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setPdfDownload: (isPdf) => {
      dispatch(actionTypes.setPDFViewAction(isPdf));
    },
    setOptionDataPDF: (isOption) => {
      dispatch(actionTypes.setOptionDataPDF(isOption));
    },
    setApiData: async (surveyId, isShortlisted) =>
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false)),
    updatePDFCounter: () => dispatch(actionTypes.updateCounter(0, 'pdfViewCounter')),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresentationComponent);
